import { useState, useEffect } from "react";

const COLORS = {
  navy: "#003366",
  navyDark: "#001f44",
  navyMid: "#004080",
  red: "#cc0000",
  greyPage: "#f0f2f5",
  greyCard: "#e5e8ed",
  greyMid: "#c8cdd6",
  greyDark: "#555e6d",
  white: "#ffffff",
  textDark: "#1a2233",
  textMid: "#3d4a5c",
};

const IMAGES = {
  logoWhite: "https://arcuchicnc.com/wp-content/uploads/2023/07/Untitled-6.png",
  logoFooter: "https://arcuchicnc.com/wp-content/uploads/2023/07/Untitled-6.png",
  factory: "https://arcuchicnc.com/wp-content/uploads/2023/07/sdfds.jpg",
  inject: "https://arcuchicnc.com/wp-content/uploads/2025/08/INJECT.jpg",
  controllerUnit: "https://arcuchicnc.com/wp-content/uploads/2023/09/1-1.png",
  blogServo: "https://arcuchicnc.com/wp-content/uploads/2024/06/blog-arcuchi-1024x576.jpg",
};

function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return width;
}

// ─── Navbar ──────────────────────────────────────────────────────────────────
function AboutNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const w = useWindowWidth();
  const isMobile = w < 768;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "Home", href: "/" },
    { label: "Solutions", href: "/#solutions" },
    { label: "Products", href: "/#products" },
    { label: "About", href: "/about" },
    { label: "Services", href: "/#services" },
    { label: "News", href: "/#news" },
    { label: "Contact", href: "/#contact" },
  ];

  return (
    <>
      <nav style={{
        background: scrolled ? "rgba(0,31,68,0.97)" : COLORS.navyDark,
        backdropFilter: "blur(10px)",
        padding: isMobile ? "0 20px" : "0 40px",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        height: 64, position: "sticky", top: 0, zIndex: 100,
        borderBottom: "1px solid rgba(204,0,0,0.25)", transition: "background 0.3s",
      }}>
        <a href="/" style={{ textDecoration: "none" }}>
          <img src={IMAGES.logoWhite} alt="Arcuchi" style={{ height: 36, objectFit: "contain" }} />
        </a>

        {!isMobile && (
          <div style={{ display: "flex", gap: 28, alignItems: "center" }}>
            {links.map(l => (
              <a key={l.label} href={l.href} style={{
                fontFamily: "Montserrat,sans-serif", fontSize: 11, fontWeight: 700,
                letterSpacing: "0.1em",
                color: l.label === "About" ? "#fff" : "rgba(255,255,255,0.65)",
                textDecoration: "none", textTransform: "uppercase", paddingBottom: 2,
                borderBottom: l.label === "About" ? `2px solid ${COLORS.red}` : "2px solid transparent",
                transition: "color 0.2s",
              }}>{l.label}</a>
            ))}
          </div>
        )}

        {!isMobile && (
          <a href="/#contact" style={{
            background: COLORS.red, color: "#fff", fontFamily: "Montserrat,sans-serif",
            fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase",
            padding: "10px 22px", textDecoration: "none", display: "inline-block",
          }}>Get Quote</a>
        )}

        {isMobile && (
          <button onClick={() => setMenuOpen(o => !o)} style={{
            background: "none", border: "none", cursor: "pointer", padding: 4,
            display: "flex", flexDirection: "column", gap: 5,
          }}>
            {[0, 1, 2].map(i => (
              <span key={i} style={{
                display: "block", width: 24, height: 2, background: "#fff",
                transition: "transform 0.3s, opacity 0.3s",
                transform: menuOpen ? i === 0 ? "rotate(45deg) translate(5px,5px)" : i === 2 ? "rotate(-45deg) translate(5px,-5px)" : "none" : "none",
                opacity: menuOpen && i === 1 ? 0 : 1,
              }} />
            ))}
          </button>
        )}
      </nav>

      {isMobile && (
        <div style={{
          position: "fixed", top: 64, left: 0, right: 0, zIndex: 99,
          background: COLORS.navyDark, maxHeight: menuOpen ? 400 : 0,
          overflow: "hidden", transition: "max-height 0.4s ease",
          borderBottom: menuOpen ? `2px solid ${COLORS.red}` : "none",
        }}>
          {links.map(l => (
            <a key={l.label} href={l.href} onClick={() => setMenuOpen(false)} style={{
              display: "block", padding: "14px 24px",
              fontFamily: "Montserrat,sans-serif", fontSize: 12, fontWeight: 700,
              color: l.label === "About" ? "#fff" : "rgba(255,255,255,0.65)",
              textDecoration: "none", textTransform: "uppercase", letterSpacing: "0.1em",
              borderBottom: "1px solid rgba(255,255,255,0.06)",
            }}>{l.label}</a>
          ))}
        </div>
      )}
    </>
  );
}

// ─── Hero ─────────────────────────────────────────────────────────────────────
function AboutHero() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  return (
    <section style={{ position: "relative", overflow: "hidden", height: isMobile ? 320 : 420 }}>
      <img src={IMAGES.factory} alt="Arcuchi Factory" style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center" }} />
      <div style={{ position: "absolute", inset: 0, background: "linear-gradient(110deg, rgba(0,15,40,0.92) 40%, rgba(0,30,70,0.65))" }} />
      <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", justifyContent: "center", padding: isMobile ? "0 24px" : "0 80px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
          <div style={{ width: 36, height: 2, background: COLORS.red }} />
          <span style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700, color: "rgba(255,150,150,0.85)", letterSpacing: "0.22em", textTransform: "uppercase" }}>Shenzhen Arcuchi Technology Co., Ltd</span>
        </div>
        <h1 style={{
          fontFamily: "Montserrat,sans-serif", fontSize: isMobile ? "clamp(28px,8vw,40px)" : "clamp(36px,4vw,56px)",
          fontWeight: 900, color: "#fff", textTransform: "uppercase", letterSpacing: "0.03em",
          lineHeight: 1.1, margin: 0,
        }}>
          About <span style={{ color: COLORS.red }}>Arcuchi</span>
        </h1>
        <p style={{ fontSize: isMobile ? 12 : 14, color: "rgba(255,255,255,0.65)", marginTop: 16, maxWidth: 480, lineHeight: 1.8, fontWeight: 300 }}>
          A comprehensive solution provider in industrial PLC servo systems and injection molding machine controllers since 2007.
        </p>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 20, fontSize: 12, color: "rgba(255,255,255,0.45)", fontFamily: "Montserrat,sans-serif" }}>
          <a href="/" style={{ color: "rgba(255,255,255,0.45)", textDecoration: "none" }}>Home</a>
          <span>›</span>
          <span style={{ color: "#fff" }}>About Us</span>
        </div>
      </div>
    </section>
  );
}

// ─── Stats Bar ────────────────────────────────────────────────────────────────
function StatsBar() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  const stats = [
    { num: "17+", label: "Years of Excellence" },
    { num: "50+", label: "Countries Served" },
    { num: "14", label: "Global Offices" },
    { num: "30K+", label: "Happy Clients" },
  ];
  return (
    <div style={{ background: COLORS.navyDark, display: "grid", gridTemplateColumns: isMobile ? "repeat(2,1fr)" : "repeat(4,1fr)" }}>
      {stats.map((s, i) => (
        <div key={s.label} style={{
          textAlign: "center", padding: isMobile ? "24px 12px" : "32px 20px",
          borderRight: i < stats.length - 1 ? "1px solid rgba(255,255,255,0.07)" : "none",
        }}>
          <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: isMobile ? 32 : 40, fontWeight: 900, color: COLORS.red, lineHeight: 1 }}>{s.num}</div>
          <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, color: "rgba(255,255,255,0.5)", marginTop: 6, letterSpacing: "0.1em", textTransform: "uppercase" }}>{s.label}</div>
        </div>
      ))}
    </div>
  );
}

// ─── Who We Are ───────────────────────────────────────────────────────────────
function WhoWeAre() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  return (
    <section style={{ padding: isMobile ? "40px 20px" : "80px 80px", background: COLORS.white }}>
      <div style={{ maxWidth: 1100, margin: "0 auto", display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: isMobile ? 40 : 72, alignItems: "center" }}>
        {/* Image */}
        <div style={{ position: "relative" }}>
          <div style={{ position: "absolute", bottom: -16, right: -16, width: "70%", height: "70%", border: `3px solid ${COLORS.red}`, zIndex: 0, display: isMobile ? "none" : "block" }} />
          <div style={{ position: "relative", zIndex: 1, overflow: "hidden" }}>
            <img src={IMAGES.controllerUnit} alt="Arcuchi Controller" style={{ width: "100%", objectFit: "contain", display: "block", background: COLORS.greyPage, padding: "32px 20px" }} />
          </div>
          <div style={{
            position: "absolute", top: -16, left: -16,
            background: COLORS.red, padding: "14px 20px", zIndex: 2,
            display: isMobile ? "none" : "block",
          }}>
            <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 22, fontWeight: 900, color: "#fff", lineHeight: 1 }}>2007</div>
            <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 9, fontWeight: 700, color: "rgba(255,255,255,0.8)", letterSpacing: "0.15em", textTransform: "uppercase", marginTop: 3 }}>Founded</div>
          </div>
        </div>

        {/* Text */}
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
            <div style={{ width: 32, height: 2, background: COLORS.red }} />
            <span style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700, color: COLORS.red, letterSpacing: "0.22em", textTransform: "uppercase" }}>Who We Are</span>
          </div>
          <h2 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "clamp(22px,2.6vw,32px)", fontWeight: 800, color: COLORS.navy, textTransform: "uppercase", letterSpacing: "0.03em", lineHeight: 1.2, margin: "0 0 20px" }}>
            Global Leader in <span style={{ color: COLORS.red }}>Industrial Control</span> Solutions
          </h2>
          <p style={{ fontSize: 13.5, color: COLORS.textMid, lineHeight: 1.9, marginBottom: 16 }}>
            Shenzhen Arcuchi Technology Co., Ltd (formerly Shenzhen Yaqi Technology Co., Ltd) is a comprehensive solution provider specializing in industrial PLC servo systems and injection molding machine controllers since 2007.
          </p>
          <p style={{ fontSize: 13.5, color: COLORS.textMid, lineHeight: 1.9, marginBottom: 16 }}>
            With deep expertise in IMM controllers, servo systems, and frequency converters, we serve manufacturers across the Pearl River Delta, Yangtze River Delta, and international markets — delivering precision-engineered products built for reliability and performance.
          </p>
          <p style={{ fontSize: 13.5, color: COLORS.textMid, lineHeight: 1.9 }}>
            Driven by self-developed software and hardware capabilities, Arcuchi empowers factories to seamlessly transform production-oriented manufacturing into service-oriented excellence.
          </p>

          <div style={{ display: "flex", gap: 20, marginTop: 28, flexWrap: "wrap", justifyContent: isMobile ? "space-around" : "flex-start" }}>
            {[["4", "Domestic Offices"], ["10", "Int'l Offices"], ["200+", "Patents & IP"]].map(([num, lbl]) => (
              <div key={lbl} style={{ textAlign: "center" }}>
                <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: isMobile ? 22 : 26, fontWeight: 900, color: COLORS.red, lineHeight: 1 }}>{num}</div>
                <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 9, color: COLORS.greyDark, letterSpacing: "0.1em", textTransform: "uppercase", marginTop: 4 }}>{lbl}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── Mission & Vision ─────────────────────────────────────────────────────────
function MissionVision() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  const cards = [
    {
      icon: "🎯",
      title: "Our Mission",
      text: "To be a reliable partner supporting the evolution of industries with cutting-edge technology and personalized solutions — enabling manufacturers worldwide to achieve greater efficiency, quality, and sustainable growth.",
      color: COLORS.red,
    },
    {
      icon: "🔭",
      title: "Our Vision",
      text: "To lead the global industrial control landscape through collaborative innovation and external empowerment, facilitating the seamless transformation of production-oriented manufacturing into service-oriented excellence.",
      color: COLORS.navy,
    },
    {
      icon: "💡",
      title: "Our Philosophy",
      text: "We operate on the principles of innovation, simplicity, and common growth — developing straightforward, powerful solutions that create lasting value for our clients, partners, and the broader manufacturing ecosystem.",
      color: COLORS.navyMid,
    },
  ];
  return (
    <section style={{ padding: isMobile ? "40px 20px" : "80px 80px", background: COLORS.greyPage }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 48 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, marginBottom: 12 }}>
            <div style={{ width: 32, height: 2, background: COLORS.red }} />
            <span style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700, color: COLORS.red, letterSpacing: "0.22em", textTransform: "uppercase" }}>Our Direction</span>
            <div style={{ width: 32, height: 2, background: COLORS.red }} />
          </div>
          <h2 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "clamp(22px,2.6vw,32px)", fontWeight: 800, color: COLORS.navy, textTransform: "uppercase", letterSpacing: "0.03em", margin: 0 }}>
            Mission, Vision & <span style={{ color: COLORS.red }}>Philosophy</span>
          </h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3,1fr)", gap: isMobile ? 16 : 24 }}>
          {cards.map(c => (
            <div key={c.title} style={{
              background: COLORS.white, padding: isMobile ? "24px 20px" : "36px 28px",
              borderTop: `4px solid ${c.color}`,
              boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
            }}>
              <div style={{ fontSize: isMobile ? 28 : 36, marginBottom: isMobile ? 10 : 16 }}>{c.icon}</div>
              <h3 style={{ fontFamily: "Montserrat,sans-serif", fontSize: isMobile ? 12 : 14, fontWeight: 800, color: COLORS.navy, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: isMobile ? 10 : 14 }}>{c.title}</h3>
              <p style={{ fontSize: isMobile ? 12.5 : 13, color: COLORS.textMid, lineHeight: 1.85 }}>{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── Core Values ─────────────────────────────────────────────────────────────
function CoreValues() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  const values = [
    { icon: "⚙️", title: "Innovation", desc: "Continuously pushing the boundaries of industrial control technology with self-developed hardware and software solutions that define the future of manufacturing." },
    { icon: "🎯", title: "Precision", desc: "Every product is engineered to exacting standards — sub-millimeter accuracy, real-time analytics, and intelligent control are the foundation of everything we build." },
    { icon: "🤝", title: "Partnership", desc: "We believe in common growth. Our success is measured by the success of our customers, and we commit fully to supporting every client at every stage of their journey." },
    { icon: "🌐", title: "Global Reach", desc: "With 14 offices spanning domestic and international markets, we bring localized expertise and world-class support to manufacturers across 50+ countries." },
    { icon: "🛡️", title: "Reliability", desc: "24/7 engineering support, 1-year warranty, and AMC contracts ensure that our clients experience zero unplanned downtime and maximum production uptime." },
    { icon: "♻️", title: "Sustainability", desc: "We design energy-efficient servo systems and frequency converters that reduce power consumption and carbon footprint without compromising machine performance." },
  ];
  return (
    <section style={{ padding: isMobile ? "40px 20px" : "80px 80px", background: COLORS.navyDark }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: isMobile ? 28 : 48 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, marginBottom: 12 }}>
            <div style={{ width: 32, height: 2, background: COLORS.red }} />
            <span style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700, color: "rgba(255,150,150,0.85)", letterSpacing: "0.22em", textTransform: "uppercase" }}>What Drives Us</span>
            <div style={{ width: 32, height: 2, background: COLORS.red }} />
          </div>
          <h2 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "clamp(22px,2.6vw,32px)", fontWeight: 800, color: "#fff", textTransform: "uppercase", letterSpacing: "0.03em", margin: 0 }}>
            Our Core <span style={{ color: COLORS.red }}>Values</span>
          </h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(3,1fr)", gap: 2 }}>
          {values.map((v, i) => (
            <ValueCard key={v.title} {...v} index={i} isMobile={isMobile} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ValueCard({ icon, title, desc, index, isMobile }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: isMobile ? "20px 16px" : "36px 28px",
        background: hovered ? "rgba(204,0,0,0.12)" : "rgba(255,255,255,0.04)",
        borderLeft: hovered ? `3px solid ${COLORS.red}` : "3px solid transparent",
        transition: "background 0.3s, border-color 0.3s",
        cursor: "default",
      }}
    >
      <div style={{ fontSize: isMobile ? 24 : 32, marginBottom: isMobile ? 10 : 14 }}>{icon}</div>
      <h3 style={{ fontFamily: "Montserrat,sans-serif", fontSize: isMobile ? 11 : 13, fontWeight: 800, color: "#fff", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: isMobile ? 8 : 12 }}>{title}</h3>
      {!isMobile && <p style={{ fontSize: 12.5, color: "rgba(255,255,255,0.58)", lineHeight: 1.85 }}>{desc}</p>}
      {isMobile && <p style={{ fontSize: 11, color: "rgba(255,255,255,0.55)", lineHeight: 1.7 }}>{desc.slice(0, 80)}…</p>}
    </div>
  );
}

// ─── Company Timeline ─────────────────────────────────────────────────────────
function Timeline() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  const events = [
    { year: "2007", title: "Company Founded", desc: "Shenzhen Yaqi Technology Co., Ltd established in Shenzhen, China — beginning our journey in industrial control systems." },
    { year: "2010", title: "First IMM Controller", desc: "Launched our flagship injection molding machine controller, setting new standards in precision and reliability for plastic manufacturers." },
    { year: "2014", title: "Servo System Launch", desc: "Introduced our advanced AC servo systems designed specifically for hydraulic press and wire forming machine applications." },
    { year: "2017", title: "International Expansion", desc: "Opened first international offices, extending our reach to Southeast Asia, the Middle East, and South America." },
    { year: "2020", title: "Rebranded to Arcuchi", desc: "Rebranded as Shenzhen Arcuchi Technology Co., Ltd to reflect our global identity and expanded product portfolio." },
    { year: "2024", title: "14 Global Offices", desc: "Now operating 4 domestic and 10 international offices, serving 50+ countries with localized engineering support." },
  ];
  return (
    <section style={{ padding: isMobile ? "40px 20px" : "80px 80px", background: COLORS.white }}>
      <div style={{ maxWidth: 1000, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 52 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, marginBottom: 12 }}>
            <div style={{ width: 32, height: 2, background: COLORS.red }} />
            <span style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700, color: COLORS.red, letterSpacing: "0.22em", textTransform: "uppercase" }}>Our Story</span>
            <div style={{ width: 32, height: 2, background: COLORS.red }} />
          </div>
          <h2 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "clamp(22px,2.6vw,32px)", fontWeight: 800, color: COLORS.navy, textTransform: "uppercase", letterSpacing: "0.03em", margin: 0 }}>
            Company <span style={{ color: COLORS.red }}>Timeline</span>
          </h2>
        </div>
        <div style={{ position: "relative" }}>
          {/* Center line */}
          {!isMobile && (
            <div style={{ position: "absolute", left: "50%", top: 0, bottom: 0, width: 2, background: COLORS.greyMid, transform: "translateX(-50%)" }} />
          )}
          <div style={{ display: "flex", flexDirection: "column", gap: isMobile ? 0 : 0 }}>
            {events.map((e, i) => (
              <TimelineItem key={e.year} {...e} index={i} isMobile={isMobile} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function TimelineItem({ year, title, desc, index, isMobile }) {
  const [hovered, setHovered] = useState(false);
  const isLeft = index % 2 === 0;

  if (isMobile) {
    return (
      <div style={{ display: "flex", gap: 20, paddingBottom: 32 }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <div style={{ width: 14, height: 14, borderRadius: "50%", background: COLORS.red, flexShrink: 0, marginTop: 4 }} />
          <div style={{ width: 2, flex: 1, background: COLORS.greyMid, marginTop: 4 }} />
        </div>
        <div style={{ paddingBottom: 8 }}>
          <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 11, fontWeight: 800, color: COLORS.red, letterSpacing: "0.1em", marginBottom: 4 }}>{year}</div>
          <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 13, fontWeight: 700, color: COLORS.navy, textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: 8 }}>{title}</div>
          <p style={{ fontSize: 12.5, color: COLORS.greyDark, lineHeight: 1.75 }}>{desc}</p>
        </div>
      </div>
    );
  }

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "grid", gridTemplateColumns: "1fr 60px 1fr",
        alignItems: "start", marginBottom: 40,
      }}
    >
      {/* Left side */}
      <div style={{ textAlign: "right", paddingRight: 32, paddingTop: 4, opacity: isLeft ? 1 : 0 }}>
        {isLeft && (
          <div style={{
            background: hovered ? COLORS.navyDark : COLORS.greyPage,
            padding: "20px 24px", display: "inline-block", textAlign: "left",
            boxShadow: hovered ? "0 8px 24px rgba(0,51,102,0.12)" : "none",
            transition: "all 0.3s", borderLeft: hovered ? `3px solid ${COLORS.red}` : `3px solid transparent`,
          }}>
            <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 11, fontWeight: 800, color: COLORS.red, letterSpacing: "0.1em", marginBottom: 6 }}>{year}</div>
            <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 13, fontWeight: 700, color: hovered ? "#fff" : COLORS.navy, textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: 8 }}>{title}</div>
            <p style={{ fontSize: 12, color: hovered ? "rgba(255,255,255,0.65)" : COLORS.greyDark, lineHeight: 1.75, maxWidth: 280 }}>{desc}</p>
          </div>
        )}
      </div>

      {/* Center dot */}
      <div style={{ display: "flex", justifyContent: "center", paddingTop: 22 }}>
        <div style={{ width: 16, height: 16, borderRadius: "50%", background: hovered ? COLORS.red : COLORS.navy, border: `3px solid ${COLORS.white}`, boxShadow: `0 0 0 2px ${hovered ? COLORS.red : COLORS.navy}`, transition: "all 0.3s", zIndex: 1 }} />
      </div>

      {/* Right side */}
      <div style={{ paddingLeft: 32, paddingTop: 4, opacity: !isLeft ? 1 : 0 }}>
        {!isLeft && (
          <div style={{
            background: hovered ? COLORS.navyDark : COLORS.greyPage,
            padding: "20px 24px",
            boxShadow: hovered ? "0 8px 24px rgba(0,51,102,0.12)" : "none",
            transition: "all 0.3s", borderLeft: hovered ? `3px solid ${COLORS.red}` : `3px solid transparent`,
          }}>
            <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 11, fontWeight: 800, color: COLORS.red, letterSpacing: "0.1em", marginBottom: 6 }}>{year}</div>
            <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 13, fontWeight: 700, color: hovered ? "#fff" : COLORS.navy, textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: 8 }}>{title}</div>
            <p style={{ fontSize: 12, color: hovered ? "rgba(255,255,255,0.65)" : COLORS.greyDark, lineHeight: 1.75, maxWidth: 280 }}>{desc}</p>
          </div>
        )}
      </div>
    </div>
  );
}

// ─── Global Presence ──────────────────────────────────────────────────────────
function GlobalPresence() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  const regions = [
    {
      flag: "🇨🇳", region: "Pearl River Delta", type: "Headquarters", offices: ["Shenzhen HQ — Shangzhi Technology Park", "Guangzhou Regional Office", "Dongguan Support Center"],
    },
    {
      flag: "🇨🇳", region: "Yangtze River Delta", type: "Domestic", offices: ["Shanghai Office", "Hangzhou Office", "Nanjing Office"],
    },
    {
      flag: "🌏", region: "Southeast Asia", type: "International", offices: ["Vietnam", "Indonesia", "Thailand", "Malaysia"],
    },
    {
      flag: "🌍", region: "Global Markets", type: "International", offices: ["Mexico", "Brazil", "Turkey", "Russia", "Portugal"],
    },
  ];
  return (
    <section style={{ padding: isMobile ? "40px 20px" : "80px 80px", background: COLORS.greyPage }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 48 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, marginBottom: 12 }}>
            <div style={{ width: 32, height: 2, background: COLORS.red }} />
            <span style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700, color: COLORS.red, letterSpacing: "0.22em", textTransform: "uppercase" }}>Worldwide Network</span>
            <div style={{ width: 32, height: 2, background: COLORS.red }} />
          </div>
          <h2 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "clamp(22px,2.6vw,32px)", fontWeight: 800, color: COLORS.navy, textTransform: "uppercase", letterSpacing: "0.03em", margin: 0 }}>
            Global <span style={{ color: COLORS.red }}>Presence</span>
          </h2>
          <p style={{ fontSize: 13.5, color: COLORS.greyDark, marginTop: 12, maxWidth: 560, margin: "12px auto 0", lineHeight: 1.75 }}>
            4 domestic offices across China and 10 international offices serving over 50 countries worldwide.
          </p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(2,1fr)", gap: isMobile ? 12 : 20 }}>
          {regions.map(r => (
            <div key={r.region} style={{ background: COLORS.white, padding: isMobile ? "18px 16px" : "28px 32px", boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}>
              <div style={{ display: "flex", alignItems: "center", gap: isMobile ? 8 : 12, marginBottom: isMobile ? 10 : 16 }}>
                <span style={{ fontSize: isMobile ? 20 : 28 }}>{r.flag}</span>
                <div>
                  <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: isMobile ? 10 : 13, fontWeight: 800, color: COLORS.navy, textTransform: "uppercase", letterSpacing: "0.04em" }}>{r.region}</div>
                  <div style={{
                    display: "inline-block", marginTop: 3,
                    background: r.type === "Headquarters" ? COLORS.red : r.type === "Domestic" ? COLORS.navy : COLORS.greyDark,
                    color: "#fff", fontFamily: "Montserrat,sans-serif", fontSize: 9, fontWeight: 700,
                    letterSpacing: "0.1em", textTransform: "uppercase", padding: "2px 8px",
                  }}>{r.type}</div>
                </div>
              </div>
              <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: isMobile ? 6 : 8 }}>
                {r.offices.map(o => (
                  <li key={o} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: isMobile ? 11 : 12.5, color: COLORS.greyDark }}>
                    <span style={{ width: 5, height: 5, borderRadius: "50%", background: COLORS.red, flexShrink: 0 }} />
                    {o}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── Why Choose Us ────────────────────────────────────────────────────────────
function WhyChooseUs() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  const reasons = [
    { num: "01", title: "Self-Developed Technology", desc: "Unlike resellers, Arcuchi owns its full IP stack — hardware designs, firmware, and software — enabling rapid customization and continuous improvement." },
    { num: "02", title: "Industry-Specific Expertise", desc: "17+ years focused exclusively on industrial control means our engineers understand injection molding, wire forming, stamping and hydraulic press challenges inside out." },
    { num: "03", title: "24/7 Global Support", desc: "Round-the-clock engineering assistance via phone, video call, and remote diagnostics — with spare parts dispatched same day from our regional warehouses." },
    { num: "04", title: "Proven Track Record", desc: "30,000+ satisfied clients across 50+ countries and 200+ patents & IP certifications demonstrate our consistent delivery of quality and innovation." },
    { num: "05", title: "Seamless Retrofitting", desc: "Our retrofit kits and upgrade services allow customers to modernize legacy machines without complete replacement, protecting capital investment." },
    { num: "06", title: "Customer-Centric Approach", desc: "Every solution is tailored to the customer's specific machine type, production environment, and operational requirements — not a one-size-fits-all product." },
  ];
  return (
    <section style={{ padding: isMobile ? "40px 20px" : "80px 80px", background: COLORS.navy }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 2fr", gap: isMobile ? 28 : 72, alignItems: "start" }}>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
              <div style={{ width: 32, height: 2, background: COLORS.red }} />
              <span style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700, color: "rgba(255,150,150,0.85)", letterSpacing: "0.22em", textTransform: "uppercase" }}>Our Advantage</span>
            </div>
            <h2 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "clamp(22px,2.6vw,34px)", fontWeight: 800, color: "#fff", textTransform: "uppercase", letterSpacing: "0.03em", lineHeight: 1.2, margin: "0 0 20px" }}>
              Why Choose <span style={{ color: COLORS.red }}>Arcuchi?</span>
            </h2>
            <p style={{ fontSize: 13, color: "rgba(255,255,255,0.55)", lineHeight: 1.85 }}>
              More than a product supplier — we are a long-term technology partner committed to your manufacturing success.
            </p>
            <a href="/#contact" style={{
              display: "inline-flex", alignItems: "center", gap: 8, marginTop: 28,
              background: COLORS.red, color: "#fff", fontFamily: "Montserrat,sans-serif",
              fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase",
              padding: "13px 28px", textDecoration: "none",
            }}>Contact Us →</a>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(2,1fr)", gap: 2 }}>
            {reasons.map(r => (
              <WhyCard key={r.num} {...r} isMobile={isMobile} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function WhyCard({ num, title, desc, isMobile }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: isMobile ? "16px 14px" : "24px 22px", cursor: "default",
        background: hovered ? "rgba(255,255,255,0.07)" : "rgba(255,255,255,0.03)",
        borderBottom: `1px solid rgba(255,255,255,0.07)`,
        borderLeft: hovered ? `3px solid ${COLORS.red}` : "3px solid transparent",
        transition: "all 0.25s",
      }}
    >
      <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: isMobile ? 9 : 10, fontWeight: 800, color: COLORS.red, letterSpacing: "0.15em", marginBottom: isMobile ? 6 : 10 }}>{num}</div>
      <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: isMobile ? 11 : 12.5, fontWeight: 700, color: "#fff", textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: isMobile ? 6 : 10 }}>{title}</div>
      {!isMobile && <p style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", lineHeight: 1.8 }}>{desc}</p>}
      {isMobile && <p style={{ fontSize: 10.5, color: "rgba(255,255,255,0.45)", lineHeight: 1.65 }}>{desc.slice(0, 70)}…</p>}
    </div>
  );
}

// ─── Products Snapshot ────────────────────────────────────────────────────────
function ProductsSnapshot() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  const products = [
    { tag: "Core Product", title: "IMM Controller", desc: "Industry-leading injection molding machine controllers with real-time cycle analytics, mold temperature control, and clamping force management." },
    { tag: "Motion Control", title: "Servo System", desc: "High-performance AC servo systems for hydraulic press, wire forming, and stamping applications with sub-millisecond response time." },
    { tag: "Drive System", title: "Frequency Converter", desc: "Energy-efficient variable frequency drives that reduce motor power consumption by up to 40% while maintaining precise speed control." },
  ];
  return (
    <section style={{ padding: isMobile ? "40px 20px" : "80px 80px", background: COLORS.greyPage }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: isMobile ? 28 : 48 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, marginBottom: 12 }}>
            <div style={{ width: 32, height: 2, background: COLORS.red }} />
            <span style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700, color: COLORS.red, letterSpacing: "0.22em", textTransform: "uppercase" }}>What We Make</span>
            <div style={{ width: 32, height: 2, background: COLORS.red }} />
          </div>
          <h2 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "clamp(22px,2.6vw,32px)", fontWeight: 800, color: COLORS.navy, textTransform: "uppercase", letterSpacing: "0.03em", margin: 0 }}>
            Our <span style={{ color: COLORS.red }}>Products</span>
          </h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3,1fr)", gap: isMobile ? 16 : 24 }}>
          {products.map(p => (
            <ProductCard key={p.title} {...p} isMobile={isMobile} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ProductCard({ tag, title, desc, isMobile }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? COLORS.navyDark : COLORS.white,
        padding: isMobile ? "22px 20px" : "32px 28px",
        boxShadow: hovered ? "0 16px 40px rgba(0,51,102,0.15)" : "0 2px 12px rgba(0,0,0,0.06)",
        transform: hovered ? "translateY(-4px)" : "none",
        transition: "all 0.3s", cursor: "default",
        borderBottom: hovered ? `3px solid ${COLORS.red}` : `3px solid transparent`,
      }}
    >
      <span style={{
        display: "inline-block", background: "rgba(204,0,0,0.1)", color: COLORS.red,
        border: `1px solid rgba(204,0,0,0.25)`, fontFamily: "Montserrat,sans-serif",
        fontSize: 9, fontWeight: 800, letterSpacing: "0.12em", textTransform: "uppercase",
        padding: "3px 10px", marginBottom: 16,
      }}>{tag}</span>
      <h3 style={{ fontFamily: "Montserrat,sans-serif", fontSize: 16, fontWeight: 800, color: hovered ? "#fff" : COLORS.navy, textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 14 }}>{title}</h3>
      <p style={{ fontSize: 13, color: hovered ? "rgba(255,255,255,0.65)" : COLORS.greyDark, lineHeight: 1.8 }}>{desc}</p>
      <div style={{ display: "inline-flex", alignItems: "center", gap: 6, marginTop: 18, fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700, color: COLORS.red, textTransform: "uppercase", letterSpacing: "0.1em" }}>
        Learn More <span style={{ transform: hovered ? "translateX(4px)" : "none", transition: "transform 0.2s", display: "inline-block" }}>→</span>
      </div>
    </div>
  );
}

// ─── CTA ──────────────────────────────────────────────────────────────────────
function AboutCTA() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  return (
    <section style={{ position: "relative", overflow: "hidden", padding: isMobile ? "60px 24px" : "80px 80px" }}>
      <img src={IMAGES.inject} alt="background" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
      <div style={{ position: "absolute", inset: 0, background: "rgba(0,15,40,0.88)" }} />
      <div style={{ position: "relative", zIndex: 1, maxWidth: 700, margin: "0 auto", textAlign: "center" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, marginBottom: 16 }}>
          <div style={{ width: 32, height: 2, background: COLORS.red }} />
          <span style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700, color: "rgba(255,150,150,0.85)", letterSpacing: "0.22em", textTransform: "uppercase" }}>Ready to Start?</span>
          <div style={{ width: 32, height: 2, background: COLORS.red }} />
        </div>
        <h2 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "clamp(24px,3vw,38px)", fontWeight: 800, color: "#fff", textTransform: "uppercase", letterSpacing: "0.03em", lineHeight: 1.2, margin: "0 0 16px" }}>
          Partner With Arcuchi for <span style={{ color: COLORS.red }}>Smarter Manufacturing</span>
        </h2>
        <p style={{ fontSize: 13.5, color: "rgba(255,255,255,0.6)", lineHeight: 1.85, marginBottom: 32 }}>
          Whether you need a standard controller, a custom servo solution, or a full machine retrofit — our engineers are ready to help you optimize every step of your production line.
        </p>
        <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap", width: isMobile ? "100%" : "auto" }}>
          <a href="/#contact" style={{
            background: COLORS.red, color: "#fff", fontFamily: "Montserrat,sans-serif",
            fontSize: 12, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase",
            padding: "14px 32px", textDecoration: "none", display: "block",
            textAlign: "center", flex: isMobile ? 1 : "none", minWidth: isMobile ? 0 : "auto",
          }}>Get a Free Quote</a>
          <a href="/#solutions" style={{
            background: "transparent", color: "#fff", fontFamily: "Montserrat,sans-serif",
            fontSize: 12, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase",
            padding: "13px 28px", border: "1px solid rgba(255,255,255,0.35)", textDecoration: "none", display: "block",
            textAlign: "center", flex: isMobile ? 1 : "none", minWidth: isMobile ? 0 : "auto",
          }}>View Solutions</a>
        </div>
      </div>
    </section>
  );
}

// ─── Footer ───────────────────────────────────────────────────────────────────
function AboutFooter() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  const cols = [
    { title: "Products", links: ["IMM Controller", "Servo System", "Frequency Converter", "Retrofit Kits"] },
    { title: "Company", links: ["About Us", "News & Events", "Blogs", "Careers"] },
    { title: "Support", links: ["Contact Us", "Technical Docs", "AMC Program", "WhatsApp Chat"] },
  ];
  return (
    <footer style={{ background: COLORS.navyDark, padding: isMobile ? "40px 20px 20px" : "48px 80px 24px" }}>
      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr 1fr" : "2fr 1fr 1fr 1fr", gap: isMobile ? 28 : 40, marginBottom: 40 }}>
        <div style={{ gridColumn: isMobile ? "1 / -1" : "auto" }}>
          <img src={IMAGES.logoFooter} alt="Arcuchi" style={{ height: 40, objectFit: "contain", marginBottom: 14, display: "block" }} />
          <p style={{ fontSize: 12, color: "rgba(255,255,255,0.45)", lineHeight: 1.8, maxWidth: 260, fontWeight: 300 }}>
            Enhance your production efficiency with advanced controllers and servos for various industrial equipment worldwide.
          </p>
        </div>
        {cols.map(col => (
          <div key={col.title}>
            <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 11, fontWeight: 700, color: "rgba(255,255,255,0.8)", letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 14, paddingBottom: 8, borderBottom: `1px solid ${COLORS.red}` }}>
              {col.title}
            </div>
            <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 8 }}>
              {col.links.map(l => <li key={l}><a href="#" style={{ fontSize: 12, color: "rgba(255,255,255,0.45)", textDecoration: "none" }}>{l}</a></li>)}
            </ul>
          </div>
        ))}
      </div>
      <div style={{ borderTop: "1px solid rgba(255,255,255,0.07)", paddingTop: 20, display: "flex", flexDirection: isMobile ? "column" : "row", justifyContent: "space-between", alignItems: "center", gap: isMobile ? 14 : 0 }}>
        <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", textAlign: isMobile ? "center" : "left" }}>
          © 2025 Shenzhen Arcuchi Technology Co., Ltd. All rights reserved.
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          {[["FB", "https://www.facebook.com/profile.php?id=100095303481787"], ["TW", "https://twitter.com/arcuchi_cnc_10"], ["IG", "https://www.instagram.com/arcuchicnc/"], ["LI", "https://www.linkedin.com/in/arcuchi-cnc-50a672287/"]].map(([label, href]) => (
            <a key={label} href={href} target="_blank" rel="noreferrer" style={{ width: 30, height: 30, background: "rgba(255,255,255,0.07)", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 2, fontSize: 10, fontFamily: "Montserrat,sans-serif", fontWeight: 700, color: "rgba(255,255,255,0.45)", textDecoration: "none" }}>
              {label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}

// ─── About Page Root ──────────────────────────────────────────────────────────
export default function AboutPage() {
  useEffect(() => {
    document.title = "About Us — Arcuchi CNC";
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;800;900&family=Open+Sans:wght@300;400;600&display=swap');
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: 'Open Sans', sans-serif; background: #f0f2f5; color: #1a2233; }
        html { scroll-behavior: smooth; }
      `}</style>
      <AboutNavbar />
      <AboutHero />
      <StatsBar />
      <WhoWeAre />
      <MissionVision />
      <CoreValues />
      <Timeline />
      <GlobalPresence />
      <WhyChooseUs />
      <ProductsSnapshot />
      <AboutCTA />
      <AboutFooter />
    </>
  );
}
